import React, { useEffect, useRef } from "react";
import { useSpring, animated } from "@react-spring/web";
import { isMobile } from "react-device-detect";
import "./../Style.css";
import desayuno from "./../pics/m_desayuno.jpg";
import sunset from "./../pics/m_sunset.jpg";
import sushi from "./../pics/m_sushi-pizza.jpg";
import comida from "./../pics/m_comida.png";
import bebida from "./../pics/m_bebida.png";
import postre from "./../pics/m_postre_.png";
import { HomeMenuIntro } from "./ContactDesktop";

export const MenuDesktop = () => {
  const refText1 = useRef();
  const refText2 = useRef();
  const refText3 = useRef();
  const refText4 = useRef();
  const refText5 = useRef();
  const refText6 = useRef();

  const [textSprings1, textApi1] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings2, textApi2] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings3, textApi3] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings4, textApi4] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings5, textApi5] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings6, textApi6] = useSpring(() => ({
    opacity: 0,
  }));

  useEffect(() => {
    textApi1.start({
      opacity: 0.9,
      delay: 200,
      transform: "translateY(0)",
      config: {
        tension: 170,
        friction: 26,
        precision: 0.01,
        duration: 400,
      },
    });

    const handleScroll = () => {
      if (refText2.current) {
        const rectText2 = refText2.current.getBoundingClientRect();
        if (rectText2.top < window.innerHeight && rectText2.bottom > 0) {
          textApi2.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText3.current) {
        const rectText3 = refText3.current.getBoundingClientRect();
        if (rectText3.top < window.innerHeight && rectText3.bottom > 0) {
          textApi3.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText4.current) {
        const rectText4 = refText4.current.getBoundingClientRect();
        if (rectText4.top < window.innerHeight && rectText4.bottom > 0) {
          textApi4.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText5.current) {
        const rectText5 = refText5.current.getBoundingClientRect();
        if (rectText5.top < window.innerHeight && rectText5.bottom > 0) {
          textApi5.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText6.current) {
        const rectText6 = refText6.current.getBoundingClientRect();
        if (rectText6.top < window.innerHeight && rectText6.bottom > 0) {
          textApi6.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [textApi1, textApi2, textApi3, textApi4, textApi5, textApi6]);

  return (
    <div className="menudiv">
      <animated.img
        ref={refText1}
        style={{
          ...textSprings1,
        }}
        src={desayuno}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText2}
        style={{
          ...textSprings2,
        }}
        src={sunset}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText3}
        style={{
          ...textSprings3,
        }}
        src={comida}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText4}
        style={{
          ...textSprings4,
        }}
        src={sushi}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText5}
        style={{
          ...textSprings5,
        }}
        src={bebida}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText6}
        style={{
          ...textSprings6,
        }}
        src={postre}
        alt=""
        className="menu_pic"
      ></animated.img>
    </div>
  );
};

export const MenuMobile = () => {
  const refText1 = useRef();
  const refText2 = useRef();
  const refText3 = useRef();
  const refText4 = useRef();
  const refText5 = useRef();
  const refText6 = useRef();

  const [textSprings1, textApi1] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings2, textApi2] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings3, textApi3] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings4, textApi4] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings5, textApi5] = useSpring(() => ({
    opacity: 0,
  }));
  const [textSprings6, textApi6] = useSpring(() => ({
    opacity: 0,
  }));

  useEffect(() => {
    textApi1.start({
      opacity: 0.9,
      delay: 200,
      transform: "translateY(0)",
      config: {
        tension: 170,
        friction: 26,
        precision: 0.01,
        duration: 400,
      },
    });

    const handleScroll = () => {
      if (refText2.current) {
        const rectText2 = refText2.current.getBoundingClientRect();
        if (rectText2.top < window.innerHeight && rectText2.bottom > 0) {
          textApi2.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText3.current) {
        const rectText3 = refText3.current.getBoundingClientRect();
        if (rectText3.top < window.innerHeight && rectText3.bottom > 0) {
          textApi3.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText4.current) {
        const rectText4 = refText4.current.getBoundingClientRect();
        if (rectText4.top < window.innerHeight && rectText4.bottom > 0) {
          textApi4.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText5.current) {
        const rectText5 = refText5.current.getBoundingClientRect();
        if (rectText5.top < window.innerHeight && rectText5.bottom > 0) {
          textApi5.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
      if (refText6.current) {
        const rectText6 = refText6.current.getBoundingClientRect();
        if (rectText6.top < window.innerHeight && rectText6.bottom > 0) {
          textApi6.start({
            opacity: 1,
            delay: 400,
            transform: "translateY(0)",
            config: {
              tension: 170,
              friction: 26,
              precision: 0.01,
              duration: 400,
            },
          });
        }
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [textApi1, textApi2, textApi3, textApi4, textApi5, textApi6]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="menudiv_m">
      <animated.img
        ref={refText1}
        style={{
          ...textSprings1,
        }}
        src={desayuno}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText2}
        style={{
          ...textSprings2,
        }}
        src={sunset}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText3}
        style={{
          ...textSprings3,
        }}
        src={comida}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText4}
        style={{
          ...textSprings4,
        }}
        src={sushi}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText5}
        style={{
          ...textSprings5,
        }}
        src={bebida}
        alt=""
        className="menu_pic"
      ></animated.img>
      <animated.img
        ref={refText6}
        style={{
          ...textSprings6,
        }}
        src={postre}
        alt=""
        className="menu_pic"
      ></animated.img>
    </div>
  );
};

export const Menu = () => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  const MobileView = () => {
    return (
      <>
        <HomeMenuIntro />
        <MenuMobile />
      </>
    );
  };

  const DesktopView = () => {
    return (
      <>
        <HomeMenuIntro />
        <MenuDesktop />
      </>
    );
  };
  return <div>{isMobile ? <MobileView /> : <DesktopView />}</div>;
};
